<template>
  <button class="btn-filter">
    <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6677 14.6147H0.908936V12.6147H19.6677V14.6147Z" fill="currentColor"/>
      <circle cx="6.36356" cy="13.4546" r="2.22727" fill="currentColor" stroke="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.909075 4.61475H19.6678V2.61475H0.909075V4.61475Z" fill="currentColor"/>
      <circle r="2.22727" transform="matrix(-1 0 0 1 14.2132 3.45457)" fill="currentColor" stroke="currentColor"/>
    </svg>

    <!-- старая иконка -->
    <!-- <svg v-if="!active" width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.41935" cy="3.66838" r="3.16838" stroke="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.95021 4.66821C10.0401 4.3503 10.0882 4.01486 10.0882 3.66818C10.0882 3.32152 10.0401 2.9861 9.95023 2.66821H20.6346V4.66821H9.95021ZM2.88939 4.66821H0V2.66821H2.88937C2.79951 2.9861 2.75143 3.32152 2.75143 3.66818C2.75143 4.01486 2.79952 4.3503 2.88939 4.66821Z" fill="currentColor"/>
      <circle cx="6.41935" cy="20.1762" r="3.16838" stroke="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.95021 21.1763C10.0401 20.8584 10.0882 20.5229 10.0882 20.1762C10.0882 19.8296 10.0401 19.4942 9.95023 19.1763H20.6346V21.1763H9.95021ZM2.88939 21.1763H0V19.1763H2.88937C2.79951 19.4942 2.75143 19.8296 2.75143 20.1762C2.75143 20.5229 2.79952 20.8584 2.88939 21.1763Z" fill="currentColor"/>
      <circle r="3.16838" transform="matrix(-1 0 0 1 14.2154 11.9223)" stroke="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6846 12.9224C10.5947 12.6045 10.5466 12.269 10.5466 11.9223C10.5466 11.5757 10.5947 11.2403 10.6845 10.9224H0.000150681V12.9224H10.6846ZM17.7454 12.9224H20.6348V10.9224H17.7454C17.8353 11.2403 17.8833 11.5757 17.8833 11.9223C17.8833 12.269 17.8352 12.6045 17.7454 12.9224Z" fill="currentColor"/>
    </svg>
    <svg v-if="active" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.72922 16.9248L16.3201 2.33395L14.9059 0.919739L0.315008 15.5106L1.72922 16.9248Z" fill="white"/>
      <path d="M15.613 16.2177L1.02216 1.62684" stroke="white" stroke-width="2"/>
    </svg> -->
  </button>
</template>

<script>
export default {
  name: 'AppButtonFilter',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="scss" scoped>
  .btn-filter {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background: $color__orange;
    color: $color__white;
    box-shadow: 0 2px 2px $color__orange;
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
    transition: .3s;

    &:hover {
      box-shadow: none;
    }

    &:active {
      box-shadow: inset 0 4px 4px rgba(44, 4, 48, 0.54);
    }
  }
</style>
